import { useQuery } from "@tanstack/react-query";
import { riskReviewKeys } from "../constants/riskReviewQueryKeys";
import riskReviewService from "../services/riskReviewService";

export const useRiskReviewDashboard = () =>
  useQuery({
    queryKey: riskReviewKeys.dashboard(),
    queryFn: riskReviewService.getDashboardStats,
    staleTime: 30000,
  });
